import { useTempQueryParamsMut } from "@/lib/hooks";
import { createContext, useContext } from "react";

export type Data = ReturnType<typeof useTempQueryParamsMut>;

const FilterSheetContext = createContext<Data | null>(null);
export const useFilterSheetContext = () => useContext(FilterSheetContext)!;
export const FilterSheetContextProvider = FilterSheetContext.Provider;
